module.exports = __webpack_public_path__ + "static/kcdc2016-811ed43cb21bc0eeea4030304e249977.jpeg";